var map = {
	"./template.betgalaxy": 2121,
	"./template.betgalaxy.tsx": 2121,
	"./template.betprofessor": 2009,
	"./template.betprofessor.tsx": 2009,
	"./template.betroyale": 2010,
	"./template.betroyale.tsx": 2010,
	"./template.default": 708,
	"./template.default.tsx": 708,
	"./template.fiestabet": 1950,
	"./template.fiestabet.tsx": 1950,
	"./template.forsport": 1951,
	"./template.forsport.tsx": 1951,
	"./template.goldenrush": 2011,
	"./template.goldenrush.tsx": 2011,
	"./template.juicybet": 2012,
	"./template.juicybet.tsx": 2012,
	"./template.junglebet": 2013,
	"./template.junglebet.tsx": 2013,
	"./template.oldgill": 2014,
	"./template.oldgill.tsx": 2014,
	"./template.puntcity": 2015,
	"./template.puntcity.tsx": 2015,
	"./template.puntgenie": 1979,
	"./template.puntgenie.tsx": 1979,
	"./template.questbet": 2016,
	"./template.questbet.tsx": 2016,
	"./template.sterlingparker": 2017,
	"./template.sterlingparker.tsx": 2017,
	"./template.sugarcastle": 2018,
	"./template.sugarcastle.tsx": 2018,
	"./template.ts": 1001,
	"./template.vikingbet": 2122,
	"./template.vikingbet.tsx": 2122,
	"./template.volcanobet": 1983,
	"./template.volcanobet.tsx": 1983,
	"./template.wellbet": 2019,
	"./template.wellbet.tsx": 2019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2800;